<div class="session-left spaceOfBr">
    <div class="emd-text d-flex warning-section p-2 mb-4">
        <i class="fa fa-warning mr-2" style="font-size: 24px; color: orangered"></i>
        <h2 class="emd-text _color_default _size_section">
            {{ content }}
        </h2>
    </div>
</div>
